import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { InterviewEntity } from './interviewApi';
import { RootState } from './store';

const initialState: Record<number, InterviewEntity> = {};

export const interviewSlice = createSlice({
  name: 'interview',
  initialState,
  reducers: {
    setInterview: (state, action: PayloadAction<InterviewEntity>) => {
      state[action.payload.id] = action.payload;
    },
    setInterviews: (state, action: PayloadAction<InterviewEntity[]>) => {
      const newState: Record<number, InterviewEntity> = {};
      for (const interview of action.payload) {
        newState[interview.id] = interview;
      }
      return newState;
    },
  },
});

export const { setInterview, setInterviews } = interviewSlice.actions;

export const selectInterview =
  (id: number) =>
  (state: RootState): InterviewEntity | undefined => {
    return state.interview[id];
  };

export const selectInterviews = (state: RootState) => {
  return state.interview;
};

export const selectSortedInterviews = createSelector(
  [selectInterviews],
  (interviews) => {
    return Object.values(interviews).sort((a, b) => a.sequence - b.sequence);
  }
);

export const selectInterviewCount = (state: RootState) => {
  return Object.keys(state.interview).length;
};

export default interviewSlice.reducer;
